import React from 'react'
import { History } from 'history'
import { ForgotPasswordContainer, ForgotPasswordForm, ForgotPasswordHeader, ValidationMessage } from 'auth/components'
import { IconTextInput } from 'uiComponents/input'
import { ActionButton } from 'uiComponents/buttons'
import { t } from 'translations'

export interface PasswordResetFinishPageProps {
    history: History
    login: (username: string, password: string) => Promise<boolean>
    resetPassword: (token: string, password: string) => Promise<boolean>
    username: string
    token: string
}

export interface PasswordResetFinishPageState {
    message: string | null
    password: string
    password2: string
}

export class PasswordResetFinishPage extends React.Component<
    PasswordResetFinishPageProps,
    PasswordResetFinishPageState
> {
    state = {
        message: null,
        password: '',
        password2: '',
    }

    checkPassStrength = () => {
        if (this.state.password.length < 10) {
            this.setState({
                message: t('auth.passwordReset.tooShort'),
            })
        } else {
            this.setState({ message: '' })
        }
    }

    resetPassword = async (e: React.FormEvent<HTMLElement>) => {
        e.preventDefault()
        try {
            if (this.state.password !== this.state.password2) {
                this.setState({ message: t('auth.passwordReset.mismatch') })
                return
            }

            this.setState({ message: '' })
            const result = await this.props.resetPassword(this.props.token, this.state.password)
            if (!result) {
                this.setState({ message: t('auth.passwordReset.linkExpired') })
                return
            }

            const loginResult = await this.props.login(this.props.username, this.state.password)
            if (loginResult) {
                this.props.history.push('/')
            } else {
                this.setState({
                    message: t('auth.passwordReset.unknownError'),
                })
            }
        } catch (e) {
            this.setState({
                message: t('auth.passwordReset.unknownError'),
            })
        }
    }

    render() {
        const canSubmit = this.state.password.length > 9 && this.state.password2

        return (
            <ForgotPasswordContainer>
                <ForgotPasswordForm noValidate onSubmit={this.resetPassword}>
                    <ForgotPasswordHeader>{t('auth.passwordReset.title')}</ForgotPasswordHeader>
                    <ValidationMessage className={this.state.message ? 'validation-message-visible' : ''}>
                        {this.state.message}
                    </ValidationMessage>
                    <IconTextInput
                        block
                        status={this.state.message ? 'error' : 'normal'}
                        type="password"
                        placeholder={t('auth.passwordReset.newPasswordPlaceholder')}
                        value={this.state.password}
                        onChange={(evt) => this.setState({ password: evt.target.value })}
                        onFinishTyping={this.checkPassStrength}
                        style={{ marginBottom: '.9em' }}
                    />
                    <IconTextInput
                        block
                        status={this.state.message ? 'error' : 'normal'}
                        type="password"
                        placeholder={t('auth.passwordReset.confirmPasswordPlaceholder')}
                        value={this.state.password2}
                        onChange={(evt) => this.setState({ password2: evt.target.value })}
                        style={{ marginBottom: '1.875em' }}
                    />
                    <ActionButton
                        size="large"
                        type="submit"
                        disabled={!canSubmit}
                        style={{ margin: '1.0625em 0 0.75em' }}
                        block
                    >
                        {t('auth.passwordReset.submit')}
                    </ActionButton>
                </ForgotPasswordForm>
            </ForgotPasswordContainer>
        )
    }
}

export default PasswordResetFinishPage
